/* eslint-disable import/prefer-default-export */
import { Routes } from '@src/constants/routes'

export const DetailsRoutes = {
  byRole: `${Routes.patternPagePath}/:identity_type(UNUSED_ROLE)/:summary_request_type/:request_type/:role_name/:role_uri/`,
  byIdentityWithoutRole: `${Routes.patternPagePath}/:identity_type(UNUSED_IDENTITY_WITHOUT_ROLE)/:summary_request_type/:request_type/:identity_name/:identity_uri/`,
  byIdentity: `${Routes.patternPagePath}/:identity_type(UNUSED_IDENTITY)/:summary_request_type/:request_type/:identity_name/:identity_uri/`,
  byIdentityWithRole: `${Routes.patternPagePath}/:identity_type(UNUSED_IDENTITY)/:summary_request_type/:request_type/:identity_name/:identity_uri/:role_name/:role_uri/`
}
